// Components
import TopBanner from '@/components/global-components/top-banner/TopBanner';
import ContactInformation from './sub-components/contact-information/ContactInformation';
import SimpleBanner from '@/components/global-components/simple-banner/SimpleBanner';
import Container from '@/components/global-components/Container';
import HubspotForm from 'react-hubspot-form'

// Themes
import theme from '@/themes/index';

const ContactUsBody = ({
  content,
  isTablet,
  isMobile,
}) => {
  let style = {
    height: '25rem', padding: '8rem 0 4rem',
  };
  if (isTablet) {
    style = {
      height: '19.75rem', paddingTop: '4.75rem',
    };
  } else if (!isMobile) {
    style = {
      height: '20rem', paddingTop: '8.75rem',
    };
  }

  const campusesContact = content.contactInformation.filter(el => el.node.locationType === 'Campus');
  const globalContact = content.contactInformation.filter(el => el.node.locationType === 'Global');

  return (
    <>
      <section className='top-banner'>
        <TopBanner {...content.topBanner} style={style} />
      </section>
      <section className='national-contact-information'>
        <Container>
          <h3>{content.nationalContactInformationTitle}</h3>
          <ContactInformation content={globalContact} />
        </Container>
      </section>
      <section className='contact-form'>
        <Container>
          <h3>{content.contactUsFormTitle}</h3>
          <HubspotForm
            portalId='8617308'
            formId='93525b97-5820-4b14-8098-25a98e7a3661'
          />
          
        </Container>
      </section>
      <section className='campuses-contact-information'>
        <Container>
          <h3>{content.campusesContactInformationTitle}</h3>
          <ContactInformation content={campusesContact} />
        </Container>
      </section>
      <section className='campuses-contact-information'>
        <SimpleBanner content={content.frequentlyAskedQuestions} />
      </section>
      <style jsx>{`
        section.contact-form h3 {    
          margin-block-start: 0;
          margin-block-end: 1rem;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        section.campuses-contact-information,
        section.contact-form,
        section.national-contact-information {
          padding: 3rem 2rem;
        }

        section.campuses-contact-information h3,
        section.national-contact-information h3 {
          line-height: 4rem;
          margin-block-end: 0;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.campuses-contact-information,
          section.contact-form,
          section.national-contact-information {
            padding: 3rem 4.5rem;
          }
        }
      `}</style>
    </>
  )
};

export default ContactUsBody;